var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('transition',{attrs:{"name":"van-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.showPopur),expression:"$store.state.showPopur"}],staticClass:"hide-popue"})]),_c('transition',{attrs:{"name":"van-slide-right"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }